import { Property, Schaden } from '@codefluegel/wowis-rest-typescript-client';
import { autorun } from 'mobx';
import { useEffect, useState } from 'react';

import { useSchadenApi } from '../ApiClient';

function useReports(currentEstate?: Property) {
  const [activeCategoryIndex, setActiveCategoryIndex] = useState(0);
  const [allReports, setAllReports] = useState<Schaden[]>();

  const damageApi = useSchadenApi();

  useEffect(
    () =>
      autorun(() => {
        async function getDamageReports() {
          try {
            const { data } = await damageApi.getAllSchaeden(
              Number(currentEstate?.objId),
              Number(currentEstate?.customerId),
            );
            setAllReports(data);
          } catch (error) {
            console.log({ error });
          }
        }
        getDamageReports();
      }),
    [damageApi, currentEstate?.customerId],
  );

  return {
    activeCategoryIndex,
    setActiveCategoryIndex,
    allReports,
    setAllReports,
  };
}

export default useReports;
